import { apiAxios } from '@/api/axios';
import type { NotificationLogDto, OffsetPage } from '@/api/types/Notification';

// Admin notifications service — wraps `GET /api/admin/notifications` (CHR-01 /
// ADR-0034; paged in CHR-04 / ADR-0044). Admin-only on the api side. Functional,
// one export per endpoint; mirrors `adminUsersService.ts` / `ordersService.ts`.
//
// Offset paging: `page` is 0-based (Spring native — maps directly to the `?page=`
// query param with NO off-by-one translation), default `size` 50. Rows arrive
// sorted `sentAt` DESC from the api inside the `OffsetPageResponse` envelope.

export const NOTIFICATIONS_PAGE_SIZE = 50;

export const getNotifications = async (
  page = 0,
  size: number = NOTIFICATIONS_PAGE_SIZE,
): Promise<OffsetPage<NotificationLogDto>> => {
  const response = await apiAxios.get<OffsetPage<NotificationLogDto>>(
    '/api/admin/notifications',
    { params: { page, size } },
  );
  return response.data;
};
